import { Typography } from "@hellocarbo/lasagne";
import { cn } from "@hellocarbo/lasagne/utils";
import { useTranslation } from "react-i18next";

import internationalIllustrationEn from "@/assets/en/trajectory-illustrations/international.png";
import internationalIllustrationFr from "@/assets/fr/trajectory-illustrations/international.png";
import PedagogicLink from "@/components/PedagogicLink";

function InternationalTargets({ fullWidth = false }: { fullWidth?: boolean }) {
  const { t, i18n } = useTranslation("trajectory");

  return (
    <div
      className={cn(
        "gap-lg flex flex-col",
        !fullWidth && "xl:grid xl:grid-cols-2"
      )}
    >
      <img
        src={
          i18n.language === "fr"
            ? internationalIllustrationFr
            : internationalIllustrationEn
        }
        alt={t("trajectory:pedagogy.targets.international.illustrationAltText")}
        className="w-full"
      />
      <div className="gap-sm flex flex-col">
        <div>
          <Typography as="h3" weight="bold" className="mb-2xs">
            {t("trajectory:pedagogy.targets.international.parisAgreement")}
          </Typography>
          <Typography step="-1">
            {t("trajectory:pedagogy.targets.international.parisAgreementText")}
          </Typography>
        </div>
        <div>
          <Typography as="h3" weight="bold" className="mb-2xs">
            {t("trajectory:pedagogy.targets.international.reductionTargets")}
          </Typography>
          <ul className="list-inside list-disc">
            <Typography as="li" step="-1">
              {t(
                "trajectory:pedagogy.targets.international.reductionTargetsItem1"
              )}
            </Typography>
            <Typography as="li" step="-1">
              {t(
                "trajectory:pedagogy.targets.international.reductionTargetsItem2"
              )}
            </Typography>
          </ul>
        </div>
        <div>
          <Typography as="h3" weight="bold" className="mb-2xs">
            {t(
              "trajectory:pedagogy.targets.international.europeanUnionAmbition"
            )}
          </Typography>
          <Typography step="-1">
            {t(
              "trajectory:pedagogy.targets.international.europeanUnionAmbitionText"
            )}
          </Typography>
        </div>
        <div>
          <PedagogicLink
            text={t("trajectory:pedagogy.targets.helpCenterText")}
            href="https://hellocarbo-25361575.hs-sites-eu1.com/knowledge/carbo-objectifs-de-r%C3%A9duction#objectifs-mondiaux"
          />
        </div>
      </div>
    </div>
  );
}

export default InternationalTargets;
